<template>
  <div class="contain">
    <!-- 검색 조건 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="{ tablet: 'top' }[$device.currentSize] ?? 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="8">
            <el-form-item :label="$t('언어 코드 OR 명')">
              <el-input v-model="searchForm.nm" @keyup.enter.native="search" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼-->
    <div class="buttons" ref="buttons">
      <el-button v-if="checkAuthActionAccess('LanSearch')" :size="size" @click="search" icon="el-icon-search">{{
        $t('검색')
      }}</el-button>
      <el-button
        v-if="checkAuthActionAccess('LanAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('LanUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('LanAdd') || checkAuthActionAccess('LanUp')"
        :size="size"
        @click="save"
        icon="el-icon-check"
        :disabled="btn.saveDisabled"
        style="float: right"
        class="hide-on-mobile"
        >{{ $t('저장') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-row :gutter="20">
      <el-col :md="16">
        <div id="out-table">
          <el-table
            :height="tableHeight"
            ref="table"
            border
            stripe
            highlight-current-row
            tooltip-effect="dark"
            :data="tableData"
            :size="size"
            :empty-text="$t('데이타 없음')"
            @row-click="handleRowClick"
            @select="handleRowChecked"
            @select-all="handleRowChecked">
            <el-table-column
              :label="tableData.length.toString()"
              type="index"
              width="55"
              align="center"
              label-class-name="data_cnt"></el-table-column>
            <el-table-column type="selection" width="45" align="center"></el-table-column>
            <el-table-column :label="$t('언어 코드')" prop="id" min-width="50" align="center"></el-table-column>
            <el-table-column :label="$t('언어 명')" prop="nm" min-width="100" align="center"></el-table-column>
            <el-table-column
              :label="$t('시스템 디폴트')"
              prop="default_"
              min-width="80"
              align="center"
              :formatter="mainVue.formatterCode"></el-table-column>
            <el-table-column :label="$t('순번')" prop="ord" min-width="50" align="center"></el-table-column>
            <el-table-column :label="$t('참조값1')" prop="ref1" min-width="100"></el-table-column>
            <el-table-column :label="$t('참조값2')" prop="ref2" min-width="100"></el-table-column>
            <el-table-column
              :label="$t('사용 가능 여부')"
              prop="useYn"
              min-width="110"
              align="center"
              :formatter="mainVue.formatterCode"></el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :md="8">
        <el-card shadow="never" :style="{ height: inputHeight + 'px' }" class="input-menu">
          <div slot="header">
            <span>{{ $t('언어') }}</span>
            <span v-if="'I' == inputForm.statu">{{ $t('추가') }}</span>
            <span v-if="'U' == inputForm.statu">{{ $t('수정') }}</span>
          </div>
          <div>
            <el-form
              :model="inputForm"
              :label-width="$device.mobile ? `` : `120px`"
              label-suffix=":"
              :size="size"
              :disabled="fromDisabled"
              @submit.native.prevent>
              <el-form-item :label="$t('언어 코드')" :error="formError.id" required>
                <el-input
                  v-model="inputForm.id"
                  maxlength="50"
                  show-word-limit
                  clearable
                  v-if="'I' === inputForm.statu"></el-input>
                <span v-else class="show_cd">{{ inputForm.id }}</span>
              </el-form-item>
              <el-form-item :label="$t('언어명')" :error="formError.nm" required>
                <el-input v-model="inputForm.nm" maxlength="250" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('시스템 디폴트')" :error="formError.default_">
                <el-checkbox v-model="inputForm.default_" :label="$t('디폴트')" border></el-checkbox>
              </el-form-item>
              <el-form-item :label="$t('순서')" :error="formError.ord" required>
                <el-input-number v-model="inputForm.ord" :min="1" :max="99"></el-input-number>
              </el-form-item>
              <el-form-item :label="$t('참조값1')">
                <el-input v-model="inputForm.ref1" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('참조값2')">
                <el-input v-model="inputForm.ref2" maxlength="50" clearable show-word-limit></el-input>
              </el-form-item>
              <el-form-item :label="$t('사용 가능 여부')" required>
                <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
              </el-form-item>
            </el-form>
            <el-button
              v-if="checkAuthActionAccess('LanAdd') || checkAuthActionAccess('LanUp')"
              :size="size"
              @click="save"
              icon="el-icon-check"
              :disabled="btn.saveDisabled"
              style="float: right"
              class="hide-on-desktop"
              >{{ $t('저장') }}</el-button
            >
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import mainVueMixin from '@/mixins/mainVueMixin'
import { initData } from '@/utils/constants'

export default {
  mixins: [mainVueMixin],

  data: function () {
    var data = initData()
    data.url = '/lan'

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()

    return data
  },
  created: function () {
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.id': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkLanId()
      }
    },
  },
  methods: {
    // 검색 조건 초기화
    initSearchForm: function () {
      return {
        nm: '',
        useYn: '',
      }
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        id: '',
        nm: '',
        ord: 1,
        ref1: '',
        ref2: '',
        default_: false,
        useYn: 'Y',
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        id: '',
        nm: '',
        ord: '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }
      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].id
      }
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.formError = this.initFormError()

      this.btn.saveDisabled = false
      this.fromDisabled = false
    },
    // 수정
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.id,
        function (result) {
          result.statu = 'U'

          this.inputForm = result

          this.formError = this.initFormError()

          this.btn.saveDisabled = false
          this.fromDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchForm,
        function (result) {
          this.tableData = result

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.saveDisabled = true
          this.fromDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        true
      )
    },
    // 저장
    save: function () {
      this.formError = this.initFormError()

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.id,
          this.inputForm,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.search()
          }.bind(this),
          true
        )
      }
    },
    chkLanId: function () {
      this.mainVue.$axios.patchNonLoading(
        this.url + '/chk/' + this.inputForm.id,
        null,
        null,
        function (result) {
          if (!result.data) {
            this.formError.id = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.id = this.$t('이미 사용중인 언어 코드입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
  },
}
</script>
